import Vue from 'vue'
import Router from 'vue-router'

import base from '@/view/base'
import index from '@/view/index'
import login from '@/view/login'
import register from '@/view/register'
import forget from '@/view/forget'
import releaseNeed from '@/view/release_need'

Vue.use(Router)

//解决跳转到相同路由报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

export default new Router({
  routes: [
  {
    path: '*',
    redirect: '/'
  }, {
    path: '/',
    name: 'base',
    component: base,
    children: [
    {
      path: '/',
      redirect: '/index'
    }, {
      path: '/index',
      name: 'index',
      component: index,
      meta: {
        title: '数据蜂'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        title: '数据蜂'
      }
    }, {
      path: '/register',
      name: 'register',
      component: register,
      meta: {
        title: '数据蜂'
      }
    }, {
      path: '/forget',
      name: 'forget',
      component: forget,
      meta: {
        title: '数据蜂'
      }
    }, {
      path: '/release_need',
      name: 'release_need',
      component: releaseNeed,
      meta: {
        title: '数据蜂'
      }
    }]
  }]
})


// WEBPACK FOOTER //
// ./src/router/index.js